import React from 'react';

export function cssBaseline(theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
        ':root': {
          // Single source of truth for safe-area-aware heights.
          // --header-h and --footer-h include the native safe area so every
          // layout (spacer, pb on main content, fixed bars) uses the same value.
          '--safe-area-top': 'env(safe-area-inset-top, 0px)',
          '--safe-area-bottom': 'env(safe-area-inset-bottom, 0px)',
          '--safe-area-left': 'env(safe-area-inset-left, 0px)',
          '--safe-area-right': 'env(safe-area-inset-right, 0px)',
          // Soft-keyboard height; 0 by default, overridden inline by the native app while the
          // keyboard is open. Used to lift fixed elements above the keyboard where needed.
          '--keyboard-height': '0px',
          '--header-h-mobile': 'calc(64px + var(--safe-area-top))',
          '--header-h-desktop': '80px',
          '--footer-h-mobile': 'calc(64px + var(--safe-area-bottom))',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          // PWA / iOS: reliable full viewport with dynamic toolbars
          minHeight: '-webkit-fill-available',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          minHeight: '-webkit-fill-available',
        },
        '#root, #__next': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          maxWidth: '100%',
          display: 'inline-block',
          verticalAlign: 'bottom',
        },
      },
    },
  };
}
